var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"el-menu"},[_c('li',{staticClass:"el-menu-item",staticStyle:{"padding-left":"20px"}},[_c('i',{class:_vm.indicator.style}),_vm._v(" "),_c('span',[_vm._v("\n      "+_vm._s(_vm.indicator.text)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d2593db","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Utilities/SaveIndicator.vue
// module id = 833
// module chunks = 4